/**
 * Component responsible to handle form elements (such as select/input) active state using the form component from garden.
 */
import $ from 'jquery'

import Form from 'garden/src/js/components/form'

export default ($el) => $el.form()
